export default [
    {
        el: '.j-title',
        langKey: 'title'
    },
    {
        el: '.j-go-btn',
        langKey: 'website'
    },
    {
        el: '.j-slogan',
        langKey: 'slogan'
    },
    {
        el: '.j-activity-time',
        langKey: 'time'
    },
    {
        el: '.j-login-btn',
        langKey: 'login'
    },
    {
        el: '.j-logout-btn',
        langKey: 'logout'
    },
    {
        el: '.j-lottery-book-btn',
        langKey: 'lotteryBook'
    },
    {
        el: '.j-get-book-btn',
        langKey: 'getMore'
    },
    {
        el: '.j-get-chance-tip',
        langKey: 'getMoreTip'
    },
    {
        el: '.j-part2-title',
        langKey: 'partTitle1'
    },
    {
        el: '.j-select-btn1',
        langKey: 'tabText1'
    },
    {
        el: '.j-select-btn2',
        langKey: 'tabText2'
    },
    {
        el: '.j-select-btn3',
        langKey: 'tabText3'
    },
    {
        el: '.j-select-btn4',
        langKey: 'tabText4'
    },
    {
        el: '.j-save-share-btn',
        langKey: 'saveShareText'
    },
    {
        el: '.j-select-kungfu-name1',
        langKey: 'bookName1'
    },
    {
        el: '.j-select-kungfu-name2',
        langKey: 'bookName2'
    },
    {
        el: '.j-select-kungfu-name3',
        langKey: 'bookName3'
    },
    {
        el: '.j-select-kungfu-name4',
        langKey: 'bookName4'
    },
    {
        el: '.j-select-kungfu-name5',
        langKey: 'bookName5'
    },
    {
        el: '.j-select-kungfu-name6',
        langKey: 'bookName6'
    },
    {
        el: '.j-select-kungfu-name7',
        langKey: 'bookName7'
    },
    {
        el: '.j-select-kungfu-name8',
        langKey: 'bookName8'
    },
    {
        el: '.j-select-kungfu-name9',
        langKey: 'bookName9'
    },
    {
        el: '.j-select-kungfu-name10',
        langKey: 'bookName10'
    },
    {
        el: '.j-select-kungfu-name11',
        langKey: 'bookName11'
    },
    {
        el: '.j-select-kungfu-name12',
        langKey: 'bookName12'
    },
    {
        el: '.j-part3-title',
        langKey: 'partTitle2'
    },
    {
        el: '.j-team-title',
        langKey: 'partTitle2'
    },
    {
        el: '.j-create-team',
        langKey: 'createTeam'
    },
    {
        el: '.j-cipher-input-tip',
        langKey: 'cipherInputTip'
    },
    {
        el: '.j-join-team',
        langKey: 'addTeam'
    },
    {
        el: '.j-cipher-label',
        langKey: 'cipherLabel'
    },
    {
        el: '.j-link-label',
        langKey: 'linkLabel'
    },
    {
        el: '.j-share-invite',
        langKey: 'goInvite'
    },
    {
        el: '.j-copy-cipher',
        langKey: 'copyText'
    },
    {
        el: '.j-copy-link',
        langKey: 'copyText'
    },
    {
        el: '.j-continue-share',
        langKey: 'goInvite'
    },
    {
        el: '.j-conclude-tip',
        langKey: 'concludeTip'
    },
    {
        el: '.j-conclude-label',
        langKey: 'concludeLabel'
    },
    {
        el: '.j-get-share-award-btn',
        langKey: 'getState1'
    },
    {
        el: '.j-lottery-title',
        langKey: 'partTitle3'
    },
    {
        el: '.j-see-award-pool',
        langKey: 'seeAward'
    },
    {
        el: '.j-lottery-skin-btn',
        langKey: 'lotteryText'
    },
    {
        el: '.j-get-more-btn',
        langKey: 'getMore'
    },
    {
        el: '.j-award-bag',
        langKey: 'awardBag'
    },
    {
        el: '.j-part4-title',
        langKey: 'partTitle4'
    },
    {
        el: '.j-download-game',
        langKey: 'download'
    },
    {
        el: '.j-lottery-book',
        langKey: 'menuTab1'
    },
    {
        el: '.j-build-team',
        langKey: 'menuTab2'
    },
    {
        el: '.j-lottery-skin',
        langKey: 'menuTab3'
    },
    {
        el: '.j-activity-rule',
        langKey: 'activityRule'
    },
    {
        el: '.j-rule-main-title',
        langKey: 'ruleMainTitle'
    },
    {
        el: '.j-rule-sub-title',
        langKey: 'ruleSubTitle'
    },
    {
        el: '.j-rule-title1',
        langKey: 'ruleText1'
    },
    {
        el: '.j-rule-text1',
        langKey: 'ruleText2'
    },
    {
        el: '.j-rule-title2',
        langKey: 'ruleText3'
    },
    {
        el: '.j-rule-text2',
        langKey: 'ruleText4'
    },
    {
        el: '.j-rule-text3',
        langKey: 'ruleText5'
    },
    {
        el: '.j-rule-text4',
        langKey: 'ruleText6'
    },
    {
        el: '.j-rule-text5',
        langKey: 'ruleText7'
    },
    {
        el: '.j-rule-text6',
        langKey: 'ruleText8'
    },
    {
        el: '.j-rule-text7',
        langKey: 'ruleText9'
    },
    {
        el: '.j-rule-text8',
        langKey: 'ruleText10'
    },
    {
        el: '.j-rule-title3',
        langKey: 'ruleText11'
    },
    {
        el: '.j-rule-text9',
        langKey: 'ruleText12'
    },
    {
        el: '.j-rule-text10',
        langKey: 'ruleText13'
    },
    {
        el: '.j-rule-text11',
        langKey: 'ruleText14'
    },
    {
        el: '.j-rule-text12',
        langKey: 'ruleText15'
    },
    {
        el: '.j-rule-text13',
        langKey: 'ruleText16'
    },
    {
        el: '.j-rule-text14',
        langKey: 'ruleText17'
    },
    {
        el: '.j-rule-title4',
        langKey: 'ruleText18'
    },
    {
        el: '.j-rule-text15',
        langKey: 'ruleText19'
    },
    {
        el: '.j-rule-text16',
        langKey: 'ruleText20'
    },
    {
        el: '.j-rule-text17',
        langKey: 'ruleText21'
    },
    {
        el: '.j-rule-title5',
        langKey: 'ruleText22'
    },
    {
        el: '.j-rule-text18',
        langKey: 'ruleText23'
    },
    {
        el: '.j-rule-text19',
        langKey: 'ruleText24'
    },
    {
        el: '.j-rule-text20',
        langKey: 'ruleText25'
    },
    {
        el: '.j-rule-text21',
        langKey: 'ruleText26'
    },
    {
        el: '.j-rule-text22',
        langKey: 'ruleText27'
    },
    {
        el: '.j-rule-text23',
        langKey: 'ruleText28'
    },
    {
        el: '.j-rule-text24',
        langKey: 'ruleText29'
    },
    {
        el: '.j-rule-text25',
        langKey: 'ruleText30'
    },
    {
        el: '.j-rule-text26',
        langKey: 'ruleText31'
    },
    {
        el: '.j-rule-text27',
        langKey: 'ruleText32'
    },
    {
        el: '.j-rule-text28',
        langKey: 'ruleText33'
    },
    {
        el: '.j-rule-text29',
        langKey: 'ruleText34'
    },
    {
        el: '.j-rule-text30',
        langKey: 'ruleText35'
    },
    {
        el: '.j-rule-text31',
        langKey: 'ruleText36'
    },
    {
        el: '.j-rule-text32',
        langKey: 'ruleText37'
    },
    {
        el: '.j-rule-text33',
        langKey: 'ruleText38'
    },
    {
        el: '.j-rule-text34',
        langKey: 'ruleText39'
    },
    {
        el: '.j-rule-text35',
        langKey: 'ruleText40'
    },
    {
        el: '.j-rule-text36',
        langKey: 'ruleText41'
    },
    {
        el: '.j-rule-text37',
        langKey: 'ruleText42'
    },
    {
        el: '.j-rule-text38',
        langKey: 'ruleText43'
    },
    {
        el: '.j-rule-text39',
        langKey: 'ruleText44'
    },
    {
        el: '.j-rule-text40',
        langKey: 'ruleText45'
    },
    {
        el: '.j-rule-text41',
        langKey: 'ruleText46'
    },
    {
        el: '.j-rule-text42',
        langKey: 'ruleText47'
    },
    {
        el: '.j-rule-title6',
        langKey: 'ruleText48'
    },
    {
        el: '.j-rule-text43',
        langKey: 'ruleText49'
    },
    {
        el: '.j-rule-text44',
        langKey: 'ruleText50'
    },
    {
        el: '.j-rule-text45',
        langKey: 'ruleText51'
    },
    {
        el: '.j-login-title',
        langKey: 'pLogin'
    },
    {
        el: '.j-login-tip',
        langKey: 'noRole'
    },
    {
        el: '.j-pServer',
        langKey: 'pServer'
    },
    {
        el: '.j-pRole',
        langKey: 'pRole'
    },
    {
        el: '.j-bind-title',
        langKey: 'popupBindTitle'
    },
    {
        el: '.j-popup-bind-confirm',
        langKey: 'bindPopupBtn1'
    },
    {
        el: '.j-award-show-text1',
        langKey: 'ruleText37'
    },
    {
        el: '.j-award-show-text2',
        langKey: 'ruleText38'
    },
    {
        el: '.j-award-show-text3',
        langKey: 'ruleText39'
    },
    {
        el: '.j-award-show-text4',
        langKey: 'ruleText40'
    },
    {
        el: '.j-award-show-text5',
        langKey: 'ruleText41'
    },
    {
        el: '.j-award-show-text6',
        langKey: 'ruleText42'
    },
    {
        el: '.j-award-show-text7',
        langKey: 'ruleText43'
    },
    {
        el: '.j-award-show-text8',
        langKey: 'ruleText44'
    },
    {
        el: '.j-award-show-text9',
        langKey: 'ruleText45'
    },
    {
        el: '.j-award-show-text10',
        langKey: 'ruleText46'
    },
    {
        el: '.j-award-show-text11',
        langKey: 'ruleText47'
    },
    {
        el: '.j-award-bag-title',
        langKey: 'awardBag'
    },
    {
        el: '.j-get-chance-condition1',
        langKey: 'taskText1'
    },
    {
        el: '.j-get-chance-condition2',
        langKey: 'taskText2'
    },
    {
        el: '.j-get-chance-condition3',
        langKey: 'taskText3'
    },
    {
        el: '.j-get-chance-condition4',
        langKey: 'taskText4'
    },
    {
        el: '.j-get-chance-condition5',
        langKey: 'taskText5'
    },
    {
        el: '.j-get-chance-condition6',
        langKey: 'taskText6'
    },
    {
        el: '.j-get-chance-award1',
        langKey: 'taskAward1'
    },
    {
        el: '.j-get-chance-award2',
        langKey: 'taskAward2'
    },
    {
        el: '.j-get-chance-award3',
        langKey: 'taskAward3'
    },
    {
        el: '.j-get-chance-book-tip',
        langKey: 'taskTip1'
    },
    {
        el: '.j-get-chance-invite-tip',
        langKey: 'taskTip2'
    },
    {
        el: '.j-get-book-title',
        langKey: 'popupGetBookTitle'
    },
    {
        el: '.j-popup-confirm',
        langKey: 'bindPopupBtn1'
    },
    {
        el: '.j-invite-title',
        langKey: 'popupInviteTitle'
    },
    {
        el: '.j-invite-tip',
        langKey: 'popupInviteTip'
    },
    {
        el: '.j-invite-label',
        langKey: 'linkLabel'
    },
    {
        el: '.j-copy-invite-link',
        langKey: 'copyText'
    },
    {
        el: '.j-copy-tip',
        langKey: 'copyShareTip'
    },
    {
        el: '.j-full-title',
        langKey: 'popupFullTitle'
    },
    {
        el: '.j-full-tip',
        langKey: 'popupFullTip'
    },
    {
        el: '.j-quit-title',
        langKey: 'popupQuitTitle'
    },
    {
        el: '.j-quit-tip1',
        langKey: 'popupQuitTip1'
    },
    {
        el: '.j-quit-tip2',
        langKey: 'popupQuitTip2'
    },
    {
        el: '.j-quit-btn',
        langKey: 'bindPopupBtn1'
    },
    {
        el: '.j-share-title',
        langKey: 'popupShareTitle'
    },
    {
        el: '.j-share-tip',
        langKey: 'popupShareTip'
    },
    {
        el: '.j-share-create',
        langKey: 'popupShareTipBtn1'
    },
    {
        el: '.j-share-join',
        langKey: 'popupShareTipBtn2'
    },
    {
        el: '.j-share-copy-tip',
        langKey: 'copyShareTip'
    },
    {
        el: '.j-copy-share-invite-link',
        langKey: 'copyShare'
    },
    {
        el: '.j-save-img-btn',
        langKey: 'saveImg'
    },
    {
        el: '.j-service-link',
        langKey: 'serviceText'
    },
    {
        el: '.j-privicy-link',
        langKey: 'privicyText'
    },
]